import React, {SyntheticEvent} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {XCloseIcon} from "../../assets/svg/x-close,icon";

const ButtonBox = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    text-align: center;
    padding: 0;
    height: 20px;
    width: 20px;
    line-height: 1;
    border-radius: 50%;
    cursor: pointer;
    font-weight: ${props => props.theme.fontWeight.bold};
    background-color: ${props => props.theme.colors.light};
    color: ${props => props.theme.colors.lightContrast};
`

interface XCloseButtonComponentProps {
    onClick?: (event: SyntheticEvent) => void;
    className?: string;
}
export const XCloseButtonComponent: React.FC<XCloseButtonComponentProps> = observer((props) => {
    return (
        <ButtonBox onClick={props.onClick} className={props.className}>
            <XCloseIcon/>
        </ButtonBox>
    )
});
